module.exports = __webpack_public_path__ + "img/OBCINA RIBNICA NA POHORJU.e010bade.png";